<template>
    <div>
        <b-row>
            <b-col>
                <h1 class="mt-5">Últimos animes agregados</h1>
            </b-col>
        </b-row>

        <div class="row mt-3 py-5">
            <div id="main-two" class="col-10 offset-1">
                <div style="margin-top: 200px" v-show="loadingState">
                    <ring-loader></ring-loader>
                    <h1>Cargando...</h1>
                </div>

                <div class="row mb-5" v-for="(chunk, index) in chunks" :key="index">
                    <div class="col-3" v-for="(episode, index) in chunk" :key="index">
                        <router-link :to="'episode/'+episode.id">
                            <b-card-group deck>
                                <!--<b-card class="shadow-lg" border-variant="secondary"
                                        :img-src="getImageURL(episode.img_url)"
                                        img-alt="Card image" img-top>
                                    <b-card-text :class="'font-weight-bold'">{{ episode.name }}</b-card-text>
                                    <b-card-text>Episode #{{episode.episode}}</b-card-text>
                                    &lt;!&ndash;<div class="top-right"><i class="fa fa-eye"></i> {{ reduceCounter(episode.seens) }}
                                    </div>&ndash;&gt;
                                </b-card>-->
                                <div class="card">
<!--                                    <img class="card-img-top" :src="getImageURL(episode.img_url)" alt="Card image cap">-->
                                    <img class="card-img-top" :src="thumbsPrefix+episode.img_url" @error="imgUrlAlt"
                                         alt="Card image cap">
                                    <div class="card-body">
                                        <h5 class="card-title font-weight-bold">{{ episode.name }}</h5>
                                        <h5 class="card-title">Episode #{{episode.episode}}</h5>
                                    </div>
                                </div>
                            </b-card-group>
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {http} from './../misc/http';
    import {RingLoader} from 'vue-spinners-css';
    import moment from "moment";
    import store from "../store";

    export default {
        name: "Recents",
        components: {
            RingLoader,
        },
        data() {
            return {
                APP_URL: 'http://legion-dashboard.test',
                WEBAPP_URL: 'https://legion-anime.test',
                CONST_CHUNK_SIZE: 4,
                ITEMS_MAX_NUMBER: 32, //88 total
                chunks: [],
                loadingState: true,
                thumbsPrefix: '',
            }
        },
        created() {
            Array.prototype.chunk = function (n) {
                if (!this.length) {
                    return [];
                }
                return [this.slice(0, n)].concat(this.slice(n).chunk(n));
            };
        },
        mounted() {
            this.setThumbPrefix();
            this.loadRecents();
        },
        methods: {
            setThumbPrefix() {
                this.thumbsPrefix = this.shuffle(this.getSpaces())[0];
            },
            getSpaces() {
                let spaces = process.env.VUE_APP_SPACES;
                spaces = spaces.split(',').map(space => {
                    return `https://la-space-${space}.sfo2.cdn.digitaloceanspaces.com/`;
                });
                //spaces.push('https://la-space.sfo2.cdn.digitaloceanspaces.com/');
                return spaces;
            },
            async loadRecents() {
                await this.$store.dispatch('loadRecentAnimes');
                this.toggleLoading(true);

                const recent_animes = this.$store.getters.recent_animes;
                const recent_expires_at = this.$store.getters.recent_expires_at;

                if (recent_animes.length === 0 || (recent_animes.length && moment().isAfter(recent_expires_at))) {
                    // http.get('/recents').then(res => {
                    //     this.toggleLoading(false);
                    //     this.setGrid(res.data.response.slice(0, this.ITEMS_MAX_NUMBER));
                    // });
                    const response = await http.get('/recents');
                    await this.$store.dispatch('setRecentAnimes', response.data.response);
                }

                this.toggleLoading(false);
                this.setGrid(recent_animes.slice(0, this.ITEMS_MAX_NUMBER));
            },
            setGrid(episodes) {
                this.chunks = episodes.chunk(this.CONST_CHUNK_SIZE);
            },
            reduceCounter(total) {
                if (total > 1000) {
                    return (total / 1000).toFixed(1) + "K";
                }

                return total;
            },
            toggleLoading(state) {
                this.loadingState = state;
            },
            getImageURL(img_url) {
                return this.shuffle(this.spaces)[0] + img_url;
            },
            imgUrlAlt(event) {
                event.target.src = "../assets/default.png";
            },
            shuffle(array) {
                return array.sort(() => Math.random() - 0.5);
            },
        }
    }
</script>

<style scoped>

</style>
